// Full Frame Image Display Script
(function() {
    function applyFullFrame() {
        // Remove all sale badges completely
        document.querySelectorAll('.badge, .badge--sale, [class*="badge"], [class*="sale-"]').forEach(function(el) {
            if (!el.classList.contains('product-card') && !el.classList.contains('collection')) {
                el.remove();
            }
        });
        
        // Fix each product card
        document.querySelectorAll('.product-card, .card--product, .card--standard').forEach(function(card) {
            // Find the inner container
            var inner = card.querySelector('.card__inner, .product-card__inner');
            if (inner) {
                // Remove grid/flex styles
                inner.style.display = 'block';
                inner.style.gridTemplateColumns = 'none';
                inner.style.width = '100%';
            }
            
            // Find image containers
            var mediaContainers = card.querySelectorAll('.card__media, .product-card__media, .product-card__image');
            mediaContainers.forEach(function(container) {
                // Make container full width
                container.style.width = '100%';
                container.style.maxWidth = '100%';
                container.style.gridColumn = 'span 2';
                container.style.flex = 'none';
                container.style.position = 'relative';
                container.style.paddingBottom = '100%';
                container.style.height = '0';
                container.style.overflow = 'hidden';
                container.style.background = '#f9f9f9';
                container.style.borderRadius = '8px';
                
                // Find and fix the image
                var img = container.querySelector('img');
                if (img) {
                    img.style.position = 'absolute';
                    img.style.top = '0';
                    img.style.left = '0';
                    img.style.width = '100%';
                    img.style.height = '100%';
                    img.style.objectFit = 'contain';
                    img.style.padding = '15px';
                    img.style.boxSizing = 'border-box';
                    img.style.transform = 'none';
                    img.style.opacity = '1';
                    img.style.visibility = 'visible';
                }
            });
            
            // Fix product info
            var info = card.querySelector('.card__information, .product-card__info');
            if (info) {
                info.style.width = '100%';
                info.style.position = 'relative';
                info.style.padding = '15px';
                info.style.textAlign = 'center';
            }
        });
        
        // Fix collection grid
        document.querySelectorAll('.collection .grid, .collection-grid').forEach(function(grid) {
            grid.style.display = 'grid';
            grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(280px, 1fr))';
            grid.style.gap = '25px';
        });
        
        console.log('Full frame image display applied');
    }
    
    // Apply immediately
    applyFullFrame();
    
    // Apply on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyFullFrame);
    }
    
    // Apply after delays for dynamic content
    setTimeout(applyFullFrame, 500);
    setTimeout(applyFullFrame, 1500);
    setTimeout(applyFullFrame, 3000);
    
    // Watch for changes
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function() {
            applyFullFrame();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();